<div class="authentication-section">
  <div class="authentication-form-section">
    <img src="assets/login.png" class="authentication-image" />
    <div class="authentication-heading-section">
      <span>Reset Password</span>
    </div>
    <div class="authentication-description-section">
      <span>Please enter your email to reset password</span>
    </div>
    <div class="authentication-input-section">
      <img
        src="assets/ic-user-onclick.png"
        class="authentication-input-image"
      />
      <input
        type="text"
        placeholder="Email ID"
        class="authentication-input"
        [(ngModel)]="passwordFormDetails.values.email"
        (keydown.enter)="reset()"
      />
      <p
        class="authentication-input-error"
        *ngIf="passwordFormDetails.errors.email"
      >
        Enter valid Email ID
      </p>
      <p class="authentication-input-error" *ngIf="globalError">
        Email is not registered with us.
      </p>
    </div>
    <div class="authentication-link-section">
      <span class="authentication-link" (click)="navigate('/login')"
        >Back to Login</span
      >
    </div>
    <div class="authentication-action-section">
      <button
        class="authentication-action"
        (click)="reset()"
        *ngIf="!button_loading_state"
      >
        RESET
      </button>
      <button class="authentication-action" *ngIf="button_loading_state">
        <div class="loader-1 center"><span></span></div>
      </button>
    </div>
  </div>
  <div class="authentication-video-section">
    <video
      src="assets/animations/auth-animation.mp4"
      type="video/mp4"
      playsinline
      [autoplay]="true"
      [muted]="true"
      [loop]="true"
      [muted]="true"
    ></video>
  </div>
</div>
